import { Box, Button, Select, MenuItem, FormControl, InputLabel, Tooltip, Paper } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import ShowChartIcon from '@mui/icons-material/ShowChart';

export const MapControls = ({
  usePrediction,
  handleTogglePrediction,
  selectedModel,
  handleModelChange,
  models,
  year,
  handleYearChange
}) => {
  return (
    <Box sx={{
      position: 'absolute',
      bottom: 60,
      left: 10,
      zIndex: 1000,
      backgroundColor: 'white',
      padding: '12px',
      borderRadius: '8px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      width: '220px'
    }}>
      <Paper 
        elevation={0} 
        sx={{ 
          p: 1, 
          mb: 1.5, 
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 1
        }}
      >
        <Tooltip title={!usePrediction ? "" : "Switch to Historical Data"}>
          <Button
            variant={!usePrediction ? "contained" : "outlined"}
            onClick={() => !usePrediction || handleTogglePrediction()}
            size={!usePrediction ? "medium" : "small"}
            startIcon={<MapIcon />}
            sx={{
              backgroundColor: !usePrediction ? '#1976d2' : 'transparent',
              '&:hover': {
                backgroundColor: !usePrediction ? '#1565c0' : 'rgba(25, 118, 210, 0.04)',
              },
              height: !usePrediction ? '40px' : '32px'
            }}
          >
            {!usePrediction ? "Viewing Historical Data" : "Historical Data"}
          </Button>
        </Tooltip>

        <Tooltip title={usePrediction ? "" : "Switch to Prediction Data"}>
          <Button
            variant={usePrediction ? "contained" : "outlined"}
            onClick={() => usePrediction || handleTogglePrediction()}
            size={usePrediction ? "medium" : "small"}
            startIcon={<ShowChartIcon />}
            sx={{
              backgroundColor: usePrediction ? '#2e7d32' : 'transparent',
              '&:hover': {
                backgroundColor: usePrediction ? '#1b5e20' : 'rgba(46, 125, 50, 0.04)',
              },
              height: usePrediction ? '40px' : '32px'
            }}
          >
            {usePrediction ? "Viewing Prediction Data" : "Prediction Data"}
          </Button>
        </Tooltip>
      </Paper>

      <FormControl fullWidth sx={{ mb: 1 }} size="small">
        {usePrediction ? (
          <>
            <InputLabel>Select Prediction Model</InputLabel>
            <Select value={selectedModel} onChange={handleModelChange} label="Select Prediction Model">
              {models.map(model => (
                <MenuItem key={model} value={model}>
                  {model.split('_').join(' ')}
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <>
            <InputLabel>Select Election Year</InputLabel>
            <Select value={year} onChange={handleYearChange} label="Select Election Year">
              {[2020, 2016, 2012, 2008].map(yearOption => (
                <MenuItem key={yearOption} value={yearOption}>
                  {yearOption} Election
                </MenuItem>
              ))}
            </Select>
          </>
        )}
      </FormControl>
    </Box>
  );
};